export interface NavLeaf {
  to: string
  label: string
}

export interface NavItem {
  label: string
  icon: string
  to?: string
  /**
   * Chave do catálogo de recursos por plano (ex.: 'veiculos.modulo'). Se o plano não incluir o recurso,
   * o Sidebar mostra o item com cadeado e leva a /plano em vez de `to`.
   */
  recurso?: string
  children?: NavLeaf[]
}

export interface NavSection {
  title: string
  items: NavItem[]
  /** Seção que só aparece para administradores. */
  somenteAdmin?: boolean
}

export const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Menu',
    items: [{ label: 'Visão Geral', icon: 'ri-dashboard-2-line', to: '/dashboard' }],
  },
  {
    title: 'Financeiro',
    items: [
      {
        label: 'Lançamentos',
        icon: 'ri-exchange-dollar-line',
        children: [
          { to: '/transacoes', label: 'Transações' },
          { to: '/notas-fiscais', label: 'Notas fiscais' },
          { to: '/grupos-itens', label: 'Grupos de itens' },
          { to: '/listas', label: 'Listas de compras' },
          { to: '/recorrencias', label: 'Recorrências' },
          { to: '/cartoes', label: 'Cartões' },
          { to: '/financiamentos', label: 'Financiamentos' },
        ],
      },
      {
        label: 'Planejamento',
        icon: 'ri-pie-chart-2-line',
        children: [
          { to: '/orcamento', label: 'Orçamento' },
          { to: '/metas', label: 'Metas' },
        ],
      },
      { label: 'Veículos', icon: 'ri-car-line', to: '/veiculos', recurso: 'veiculos.modulo' },
      { label: 'Relatórios', icon: 'ri-bar-chart-box-line', to: '/relatorios' },
      { label: 'Insights', icon: 'ri-lightbulb-flash-line', to: '/insights' },
      {
        label: 'Cadastros',
        icon: 'ri-folder-2-line',
        children: [
          { to: '/contas', label: 'Contas' },
          { to: '/categorias', label: 'Categorias' },
        ],
      },
    ],
  },
  {
    title: 'Integrações',
    items: [
      { label: 'Contas Pluggy', icon: 'ri-plug-line', to: '/pluggy' },
    ],
  },
  {
    title: 'Sistema',
    items: [
      { label: 'Tutoriais', icon: 'ri-graduation-cap-line', to: '/tutoriais' },
      { label: 'Meu plano', icon: 'ri-vip-crown-line', to: '/plano' },
      { label: 'Compartilhamento', icon: 'ri-share-line', to: '/compartilhamento' },
      { label: 'Configurações', icon: 'ri-settings-3-line', to: '/configuracoes' },
    ],
  },
  {
    title: 'Administração',
    somenteAdmin: true,
    items: [
      { label: 'Assinaturas', icon: 'ri-shield-star-line', to: '/admin' },
      { label: 'Usuários', icon: 'ri-team-line', to: '/usuarios' },
      { label: 'Configurações', icon: 'ri-tools-line', to: '/admin/config/planos' },
    ],
  },
]

export interface NavSearchResult {
  to: string
  label: string
  trail: string
  icon: string
}

export const NAV_SEARCH_INDEX: NavSearchResult[] = NAV_SECTIONS.flatMap((section) =>
  section.items.flatMap((item) =>
    item.children
      ? item.children.map((c) => ({ to: c.to, label: c.label, trail: `${section.title} › ${item.label}`, icon: item.icon }))
      : [{ to: item.to!, label: item.label, trail: section.title, icon: item.icon }],
  ),
)

export function breadcrumbFor(pathname: string): string[] {
  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      if (item.to && pathname.startsWith(item.to)) return [section.title, item.label]
      const child = item.children?.find((c) => pathname.startsWith(c.to))
      if (child) return [section.title, item.label, child.label]
    }
  }
  return []
}
